<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ChTitle" id="ch14"><a id="ch14aa"></a><a id="ch14a"></a><a id="page_36"></a><a href="#/Contents#rch14"><span class="underline">FLUBBED HEADLINES</span></a></h3>
<p class="center1"><span><i>Whether silly, naughty, or just plain bizarre, they’re all real.</i></span></p>
<p class="center2z"><span><i><b>Climber Who Cut Off Arm to Escape Speaking at MSU</b></i></span></p>
<p class="center2z"><span>P<span class="small">ICTURES FROM UNDERCOVER</span> H<span class="small">OOTERS BUST RELEASED</span></span></p>
<p class="center2z"><span><b>Farm Bureau Estimates Crap Damage at $207 Million</b></span></p>
<p class="center2z"><span><i>Garbage truck lands on Saturn</i></span></p>
<p class="center2z"><span>Pedestrian deaths largely flat in U.S., Maryland</span></p>
<p class="center2z"><span><i><b>New President at Kansas City Fed</b></i></span></p>
<p class="center2z"><span>U<span class="small">NMARRIED</span> C<span class="small">OUPLES</span> F<span class="small">IND</span> D<span class="small">IVORCE</span> D<span class="small">IFFICULT</span></span></p>
<p class="center2z"><span>Padres pitcher Latos writes ‘I hate SF’ on balls</span></p>
<p class="center2z"><span>Four More Newspapers Switch to Offset; Conversions Not Always Soomth</span></p>
<p class="center2z"><span><i><b>6-year-old girl just found after 26 years</b></i></span></p>
<p class="center2z"><span><i>1 in 5 U.S. moms have babies with multiple dads, study says</i></span></p>
<p class="center2z"><span><b>Marijuana Supporters at Record High</b></span></p>
<p class="center2z"><span>A-Rod Gets Hit, Colon hurt</span></p>
<p class="center2z"><span><i>Bugs Flying Around with Wings Are Flying Bugs</i></span></p>
<p class="center2z"><span><b>For Towns Hold Elections</b></span></p>
<p class="center2z"><span><b>Northfield Plans to Plan Strategic Plan</b></span></p>
<p class="center2z"><span><i>Troutt named to Salmon Board</i></span></p>
<p class="center2z"><span><i><b>B<span class="small">ISHOPS</span> A<span class="small">GREE</span> S<span class="small">EX</span> A<span class="small">BUSE</span> R<span class="small">ULES</span></b></i></span></p>
<p class="center2z"><span>Former Jets reflect on impact of 9/11 attacks</span></p>
<p class="center2z"><span>Every Students Counts</span></p>
<p class="center2z"><span><i><b>Woman accused of mugging a man using a walker</b></i></span></p>
<p class="center2z"><span><b>150th Year for Dead and Blind Institute</b></span></p>
<p class="center2z"><span><i><b>Obama to Recruit Clinton’s Top Fun Raisers</b></i></span></p>
<p class="center2z"><span>Church member donates organ to St. Aloysius</span></p>
<p class="center2z"><span>Texans Support Death Penalty, but Only for the Guilty</span></p>
<div class="box">
<p class="center7"><span><b>The average U.S. household has about 40 electric motors.</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter014.vue?7c43d09a